// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { Unidade } from '../planejamento/unidade.model';
import { ImovelOcorrencia } from './imovel-ocorrencia.model';

export class Imovel extends BaseResourceModel {
  constructor(
    public id?: number,
    public situacao?: 'PROPRIO' | 'EM_AQUISICAO' | 'CEDIDO' | 'RECEBIDO' | 'LOCADO',
    public data_aquisicao?: Date,
    public data_construcao?: Date,
    public vencimento_seguro?: Date,
    public valor_aquisicao?: number,
    public valor_terreno?: number,
    public valor_construcao?: number,
    public matricula?: string,
    public descricao?: string,
    public topografia?: string,
    public area_construcao?: number,
    public area_terreno?: number,
    public cep?: string,
    public endereco?: string,
    public num_endereco?: string,
    public bairro?: string,
    public municipio?: string,
    public uf?: string,
    public complemento?: string,
    public unidade?: Unidade,
    public orgao?: Orgao,
    public ocorrencias?: ImovelOcorrencia[],
  ) {
    super();
  }

  static converteJson(json: any): Imovel {
    return Object.assign(new Imovel(), json);
  }
}
